(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("QN", [], factory);
	else if(typeof exports === 'object')
		exports["QN"] = factory();
	else
		root["QN"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _core = __webpack_require__(43);
	
	var _core2 = _interopRequireDefault(_core);
	
	var _ajax = __webpack_require__(28);
	
	var _ajax2 = _interopRequireDefault(_ajax);
	
	var _qianniuPc = __webpack_require__(8);
	
	var _qianniuPc2 = _interopRequireDefault(_qianniuPc);
	
	var _qianniuPcApiType = __webpack_require__(5);
	
	var _qianniuPcApiType2 = _interopRequireDefault(_qianniuPcApiType);
	
	var _ajax3 = __webpack_require__(33);
	
	var _ajax4 = _interopRequireDefault(_ajax3);
	
	var _qianniuPcApp = __webpack_require__(36);
	
	var _qianniuPcApp2 = _interopRequireDefault(_qianniuPcApp);
	
	var _qianniuPcEnv = __webpack_require__(38);
	
	var _qianniuPcEnv2 = _interopRequireDefault(_qianniuPcEnv);
	
	var _qianniuPcGateway = __webpack_require__(41);
	
	var _qianniuPcGateway2 = _interopRequireDefault(_qianniuPcGateway);
	
	var _qianniuPcTop = __webpack_require__(42);
	
	var _qianniuPcTop2 = _interopRequireDefault(_qianniuPcTop);
	
	var _qianniuPcEvent = __webpack_require__(39);
	
	var _eventOld = __webpack_require__(34);
	
	var _qianniuPcAutoPlug = __webpack_require__(37);
	
	var _qianniuPcAutoPlug2 = _interopRequireDefault(_qianniuPcAutoPlug);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var QN_APP = _qianniuPcApiType2['default'].QN_APP,
	    QN_GATEWAY = _qianniuPcApiType2['default'].QN_GATEWAY,
	    TOP = _qianniuPcApiType2['default'].TOP;
	
	
	_core2['default'].addInvoker(_ajax2['default']).addInvoker((0, _qianniuPc2['default'])(QN_APP)).addInvoker((0, _qianniuPc2['default'])(QN_GATEWAY)).addInvoker((0, _qianniuPc2['default'])(TOP)).addInvoker((0, _qianniuPc2['default'])());
	
	_core2['default'].plug({
	  API_TYPE: _qianniuPcApiType2['default'],
	
	  ajax: _ajax4['default'],
	  app: _qianniuPcApp2['default'],
	  env: _qianniuPcEnv2['default'],
	  gateway: _qianniuPcGateway2['default'],
	  top: _qianniuPcTop2['default'],
	
	  on: _qianniuPcEvent.on,
	  off: _qianniuPcEvent.off,
	  emit: _qianniuPcEvent.emit,
	
	  regEvent: _eventOld.regEvent,
	  unregEvent: _eventOld.unregEvent,
	  postEvent: _eventOld.postEvent,
	
	  autoPlug: _qianniuPcAutoPlug2['default']
	});
	
	exports['default'] = _core2['default'];
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(24),
	    isObjectLike = __webpack_require__(25);
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	 * classified as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	 * @example
	 *
	 * _.isNumber(3);
	 * // => true
	 *
	 * _.isNumber(Number.MIN_VALUE);
	 * // => true
	 *
	 * _.isNumber(Infinity);
	 * // => true
	 *
	 * _.isNumber('3');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' ||
	    (isObjectLike(value) && baseGetTag(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 3 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _qianniuPcAppDetect = __webpack_require__(7);
	
	var _qianniuPcAppDetect2 = _interopRequireDefault(_qianniuPcAppDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _settings = {
	  /**
	   * 是否使用 Ajax 发送网关请求，在千牛内默认不使用
	   * @type {Boolean}
	   */
	  useAjax: !(_qianniuPcAppDetect2['default'].isQianniu || window.workbench),
	  /**
	   * 设置客户端代理请求的网关接口返回结果和使用Ajax请求的返回结果一致
	   * 1. 数据外壳去除 `xxx_xxx_response` 的包裹，如：`multi_resource_numbers_my_get_post_response`
	   * 2. 数据结果对象的 key 为 camelcase 形式
	   */
	  response_style: 'h5_style'
	};
	
	exports['default'] = {
	
	  /**
	   * 配置网关
	   * @param  {Object} options
	   * @param  {Boolean} options.useAjax optional 是否使用 Ajax 发起网关请求
	   * @param  {String} options.response_style optional 返回结果形式
	   */
	  setup: function setup(options) {
	    _assign2['default'].deep(_settings, options);
	  },
	
	
	  /**
	   * 获取配置，如果传入 key，则返回对应 key 的配置信息；如果未传，则返回全量配置的拷贝。
	   * @param  {String} key optional 配置 key
	   * @return {Any}    单个或全部配置信息
	   */
	  get: function get(key) {
	    return key ? _settings[key] : _assign2['default'].deep({}, _settings);
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var API_TYPE = {
	  QN_APP: 'QN.app',
	  QN_GATEWAY: 'QN.gateway',
	  QN_JDY: 'QN.jdy',
	  TOP: 'QN.top',
	  AJAX: 'ajax'
	};
	
	exports['default'] = API_TYPE;
	module.exports = exports['default'];

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	var _isPlainObject = __webpack_require__(26);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _each = __webpack_require__(22);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function assign(target) {
	  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  _extends.apply(undefined, [target].concat(sources));
	  return target;
	}
	
	function deep(target) {
	  for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	    sources[_key2 - 1] = arguments[_key2];
	  }
	
	  (0, _each2.default)(sources, function (source) {
	    (0, _each2.default)(source, function (v, k) {
	      if ((0, _isArray2.default)(v)) {
	        target[k] = (0, _isArray2.default)(target[k]) ? target[k] : [];
	        deep(target[k], v);
	        return;
	      }
	      if ((0, _isPlainObject2.default)(v)) {
	        target[k] = (0, _isPlainObject2.default)(target[k]) ? target[k] : {};
	        deep(target[k], v);
	        return;
	      }
	      target[k] = v;
	    });
	  });
	  return target;
	}
	
	assign.deep = deep;
	
	exports.default = assign;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  isQianniu: /(AEF|Qianniu)\/[\d\.]+/i.test(navigator.userAgent)
	};
	module.exports = exports["default"];

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invoker = __webpack_require__(9);
	
	var _qianniuPcGatewayInvokeTransform = __webpack_require__(29);
	
	var _qianniuPcGatewayInvokeTransform2 = _interopRequireDefault(_qianniuPcGatewayInvokeTransform);
	
	var _qianniuPcRoutesComplete = __webpack_require__(31);
	
	var _qianniuPcRoutesComplete2 = _interopRequireDefault(_qianniuPcRoutesComplete);
	
	var _qianniuPcInvokeNative = __webpack_require__(30);
	
	var _qianniuPcInvokeNative2 = _interopRequireDefault(_qianniuPcInvokeNative);
	
	var _qianniuPcApiType = __webpack_require__(5);
	
	var _qianniuPcApiType2 = _interopRequireDefault(_qianniuPcApiType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var QN_GATEWAY = _qianniuPcApiType2['default'].QN_GATEWAY;
	
	
	function InvokerQianniu() {
	  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'QN';
	
	  var Invoker = (0, _invoker.createInvoker)(type);
	
	  switch (type) {
	    case QN_GATEWAY:
	      Invoker.use(_qianniuPcGatewayInvokeTransform2['default']);
	      break;
	    default:
	  }
	  Invoker.use(_qianniuPcRoutesComplete2['default']).use(_qianniuPcInvokeNative2['default']);
	
	  return Invoker;
	}
	
	exports['default'] = InvokerQianniu;
	module.exports = exports['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createInvoker = createInvoker;
	
	var _uuid2 = __webpack_require__(54);
	
	var _uuid3 = _interopRequireDefault(_uuid2);
	
	var _defer = __webpack_require__(52);
	
	var _defer2 = _interopRequireDefault(_defer);
	
	var _context = __webpack_require__(14);
	
	var _context2 = _interopRequireDefault(_context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BaseInvoker = function () {
	  BaseInvoker.use = function use(ware) {
	    this.middlewares.push(ware);
	    return this;
	  };
	
	  function BaseInvoker(options) {
	    _classCallCheck(this, BaseInvoker);
	
	    this.id = this.uuid();
	    this.context = null;
	
	    this.__X__ = options.__X__;
	    this.context = new _context2.default(options);
	    this.constructor.instancePool[this.id] = this;
	  }
	
	  BaseInvoker.prototype.uuid = function uuid() {
	    return (0, _uuid3.default)();
	  };
	
	  BaseInvoker.prototype.call = function call() {
	    var _this = this;
	
	    var i = 0;
	    var context = this.context;
	
	    var middlewares = this.constructor.middlewares;
	    var deferred = (0, _defer2.default)();
	
	    var next = function next(error) {
	      var middleware = middlewares[i];
	
	      if (error) {
	        context.error = context.error || error; // 只保留最早发生的 error
	      }
	
	      if (!middleware) {
	        return _this.end(deferred);
	      }
	
	      // some middleware info to context
	      context.middleware = {
	        index: i,
	        fn: middleware
	      };
	
	      i++;
	
	      try {
	        middleware(context, next);
	      } catch (ex) {
	        next(ex);
	      }
	    };
	
	    next();
	
	    return deferred.promise;
	  };
	
	  BaseInvoker.prototype.end = function end(deferred) {
	    var context = this.context;
	    // avoid ending multiple times
	
	    if (!context) return;
	    var response = context.response,
	        error = context.error,
	        callback = context.callback;
	
	
	    if (error) {
	      callback.error && callback.error(error);
	      deferred.reject(error);
	    } else {
	      callback.success && callback.success(response.body);
	      deferred.resolve(response.body);
	    }
	
	    this.destroy();
	  };
	
	  BaseInvoker.prototype.destroy = function destroy() {
	    delete this.constructor.instancePool[this.id];
	    // this.context.destroy();
	    for (var key in this) {
	      if (!this.hasOwnProperty(key)) continue;
	      delete this[key];
	    }
	  };
	
	  return BaseInvoker;
	}();
	
	BaseInvoker.type = '';
	BaseInvoker.sync = false;
	BaseInvoker.instancePool = {};
	BaseInvoker.middlewares = [];
	exports.default = BaseInvoker;
	function createInvoker(type) {
	  var _class, _temp;
	
	  return _temp = _class = function (_BaseInvoker) {
	    _inherits(Invoker, _BaseInvoker);
	
	    function Invoker() {
	      _classCallCheck(this, Invoker);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _possibleConstructorReturn(this, _BaseInvoker.call.apply(_BaseInvoker, [this].concat(args)));
	    }
	
	    return Invoker;
	  }(BaseInvoker), _class.type = type, _class.sync = false, _class.middlewares = [], _temp;
	}

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EventEmitter = exports.slice = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _isFunction = __webpack_require__(68);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _each = __webpack_require__(62);
	
	var _each2 = _interopRequireDefault(_each);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Check if there is an array for holding event options in the options pool object, create one if not.
	 * @param  {Object} optionsPool Options pool object
	 * @param  {String} ev          Event name
	 * @return {Array}              Options array of event
	 */
	function checkOptions(optionsPool, ev) {
	  return optionsPool[ev] = optionsPool[ev] || [];
	}
	
	/**
	 * Delete event options at indexes.
	 * @param  {Array} options      Options array
	 * @param  {Array}  indexes     Array of indexes to be deleted
	 */
	function deleteOptionsAtIndexes() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var indexes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  // Make indexes decrease and collaborate with `splice` to delete correctely
	  (0, _each2.default)(indexes.sort().reverse(), function (index) {
	    options.splice(index, 1);
	  });
	}
	
	/**
	 * Create a TypeError of callback
	 * @param  {String} ev Event name
	 * @return {TypeError}
	 */
	function callbackTypeError(ev) {
	  return new TypeError('Event callback for ' + ev + ' must be function.');
	}
	
	/**
	 * Slice event string such as:
	 * balabala
	 * balabala.xxx
	 * page.balabala
	 * @param  {String} ev            event string
	 * @return {Object} result        slice result, an object of event info
	 * @return {string} result.type   event type
	 * @return {string} result.name   true event
	 * @return {string} result.value  raw event passed in
	 * @return {string} result.center event center to register in
	 */
	function slice(ev) {
	  var r = /^(page|app|global)\.(.+)$/i;
	
	  /**
	   * if none of formats below, prefix default type.
	   * page.foo
	   * app.foo.bar
	   * global.foo.bar
	   */
	  if (!r.test(ev)) {
	    ev = 'page.' + ev;
	  }
	
	  var match = ev.match(r);
	  /**
	   * lowercase to support different prefix like:
	   * page.close
	   * Page.close
	   * Global.DidBecomeActive
	   */
	  var type = match[1].toLowerCase();
	  var name = match[2];
	
	  return {
	    type: type,
	    name: name,
	    value: type + '.' + name
	  };
	}
	
	var EventEmitter = function () {
	  function EventEmitter() {
	    _classCallCheck(this, EventEmitter);
	
	    this.optionsPool = {
	      // click: [{notify, once: false}],
	      // touch: [{notify, once: true}],
	    };
	  }
	
	  /**
	   * Register event
	   * @param  {String}   ev              Event name
	   * @param  {Function} callback        Event callback when event is emitted
	   * @param  {Object}   settings        Register settings
	   * @param  {Boolean}  settings.once   Indicate if callback can only be emitted once
	   * @return {Promise}
	   */
	
	
	  EventEmitter.prototype.on = function on(ev, callback) {
	    var settings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    var options = checkOptions(this.optionsPool, ev);
	    if ((0, _isFunction2.default)(callback)) {
	      var option = _extends({ notify: callback }, settings);
	      options.push(option);
	      return Promise.resolve();
	    } else {
	      var error = callbackTypeError(ev);
	      return Promise.reject(error);
	    }
	  };
	
	  /**
	   * Unregister event
	   * @param  {String}   ev              Event name
	   * @param  {Function} callback        Event callback to be unregistered
	   * @return {Promise}
	   */
	
	
	  EventEmitter.prototype.off = function off(ev, callback) {
	    var options = checkOptions(this.optionsPool, ev);
	
	    // Unregister all callbacks if no callback argument.
	    if (!callback) {
	      this.optionsPool[ev] = [];
	      return Promise.resolve();
	    }
	
	    if ((0, _isFunction2.default)(callback)) {
	      var indexes = [];
	      (0, _each2.default)(options, function (o, i) {
	        if (o.notify !== callback) return;
	        indexes.push(i);
	      });
	      deleteOptionsAtIndexes(options, indexes);
	      return Promise.resolve();
	    } else {
	      var error = callbackTypeError(ev);
	      return Promise.reject(error);
	    }
	  };
	
	  /**
	   * Register event only once, automaticlly unregistered after the event is emitted.
	   * @param  {String}   ev              Event name
	   * @param  {Function} callback        Event callback when event is emitted
	   * @return {Promise}
	   */
	
	
	  EventEmitter.prototype.once = function once(ev, callback) {
	    return this.on(ev, callback, { once: true });
	  };
	
	  /**
	   * Emit event
	   * @param  {String} ev   Event name
	   * @param  {Any}    arg[0] 1st arg passed to notify callback.
	   * @param  {Any}    arg[1] 2nd arg passed to notify callback.
	   * @param  {Any}    ...
	   * @param  {Any}    arg[n] nth arg passed to notify callback.
	   * @return {Promise}
	   */
	
	
	  EventEmitter.prototype.emit = function emit(ev) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var options = checkOptions(this.optionsPool, ev);
	    var indexes = [];
	    (0, _each2.default)(options, function (o, i) {
	      (0, _isFunction2.default)(o.notify) && o.notify.apply(o, args);
	      o.once && indexes.push(i);
	    });
	    // Delete once options
	    deleteOptionsAtIndexes(options, indexes);
	    return Promise.resolve();
	  };
	
	  return EventEmitter;
	}();
	
	exports.slice = slice;
	exports.EventEmitter = EventEmitter;

/***/ },
/* 11 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  var deferred = {
	    always: function always() {
	      var _promise, _promise2;
	
	      (_promise = this.promise).then.apply(_promise, arguments);
	      (_promise2 = this.promise).catch.apply(_promise2, arguments);
	      return this;
	    }
	  };
	  deferred.promise = new Promise(function (resolve, reject) {
	    deferred.resolve = resolve;
	    deferred.reject = reject;
	  });
	  return deferred;
	};
	
	module.exports = exports["default"];

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tryParse = tryParse;
	exports.tryStringify = tryStringify;
	function tryParse(target) {
	  var result = void 0;
	
	  try {
	    result = JSON.parse(target);
	  } catch (ex) {
	    result = target;
	  }
	
	  return result;
	}
	
	function tryStringify(target) {
	  var result = void 0;
	
	  try {
	    result = JSON.stringify(target);
	  } catch (ex) {
	    result = target;
	  }
	
	  return result;
	}

/***/ },
/* 13 */
[77, 49],
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _each = __webpack_require__(16);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _mapLite = __webpack_require__(53);
	
	var _mapLite2 = _interopRequireDefault(_mapLite);
	
	var _isFunction = __webpack_require__(19);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 整个请求生命周期中的上下文，用于保留各种状态，并实现 core/middleware/plugin 的数据共享
	 */
	var Context = function () {
	  // Core 引用
	
	  // 未经处理的原始响应
	  // 接口请求错误 如：{code: '', msg: ''}
	  // context 全局唯一 id
	  function Context(options) {
	    _classCallCheck(this, Context);
	
	    this.id = '';
	    this.api = { // 接口信息
	      type: '', // 接口类型
	      alias: '', // 接口别名，用途：业务打点
	      uri: '', // 接口标识符
	      routes: [] // 接口寻址路径，用途：发起真正的接口请求
	    };
	    this.middleware = { // 当前正在执行的中间件的信息
	      index: 0, // 当前中间件的序号
	      fn: undefined // [暂未使用] 当前正在执行的中间件函数
	    };
	    this.state = new _mapLite2.default();
	    this.error = null;
	    this.rawReq = null;
	    this.rawRes = null;
	    this.request = { // 接口请求
	      method: 'GET', // [部分使用] 接口请求方法，同 http method
	      headers: {// [暂未使用] 接口请求头，同 http request headers
	        // 'Content-Type': '',
	      },
	      query: {}, // 接口请求入参，主要为业务入参
	      body: null, // [暂未使用] 接口请求体
	      timeout: false, // `Number` 超时时间 ms： false 或 0 表示不超时
	      settings: {// 接口请求设置
	        // crossOrigin: true,
	        // withCredentials: true,
	        // jsonpCallback: 'xxx',
	      }
	    };
	    this.response = { // 接口响应
	      headers: {}, // [暂未使用] 接口响应头，同 http response headers
	      body: null // 接口响应体
	    };
	    this.callback = {
	      // success   () {},         // 成功回调函数
	      // error     () {},         // 失败回调函数
	      // notify    () {},         // 通知回调函数
	      // beforeXXX () {},         // 前置钩子函数
	      // afterXXX  () {},         // 后置钩子函数
	    };
	    this.__X__ = null;
	    var request = this.request,
	        callback = this.callback;
	
	    this.__X__ = options.__X__;
	    this.rawReq = options;
	    this.api = options.api;
	    request.method = options.method || 'GET';
	    request.headers = options.headers || null;
	    request.query = options.query;
	    request.timeout = options.timeout || false;
	    request.settings = options.settings;
	    callback.success = options.success;
	    callback.error = options.error;
	    callback.notify = options.notify;
	  }
	
	  /**
	   * Get state by key or get state only for current middleware.
	   * @param  {Numner|String} optional key
	   * @return {Object}
	   */
	  // 未经处理的原始请求
	  // [暂未使用] 上下文数据，用途：在 middleware 间传递数据
	
	
	  Context.prototype.getState = function getState(key) {
	    var state = this.state;
	
	    if (typeof key === 'undefined') {
	      key = this.middleware.fn;
	    }
	    var value = state.get(key);
	    if (!value) {
	      value = {};
	      state.set(key, value);
	    }
	    return value;
	  };
	
	  // emit(ev, ...args) {
	  //   this.__X__.emit(ev, ...args);
	  // }
	
	  Context.prototype.destroy = function destroy() {
	    for (var key in this) {
	      if (!this.hasOwnProperty(key)) continue;
	      delete this[key];
	    }
	  };
	
	  return Context;
	}();
	
	exports.default = Context;
	module.exports = exports['default'];

/***/ },
/* 15 */
6,
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = each;
	
	var _isNumber = __webpack_require__(2);
	
	var _isNumber2 = _interopRequireDefault(_isNumber);
	
	var _isObject = __webpack_require__(3);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isArray = __webpack_require__(1);
	
	var _isArray2 = _interopRequireDefault(_isArray);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function each(obj, iterator) {
	  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  if ((0, _isObject2.default)(obj) && !(0, _isArray2.default)(obj)) {
	    for (var key in obj) {
	      if (!obj.hasOwnProperty(key)) continue;
	      if (iterator.call(context, obj[key], key, obj) === false) break;
	    }
	  } else if ((0, _isNumber2.default)(obj.length)) {
	    for (var i = 0; i < obj.length; i++) {
	      if (iterator.call(context, obj[i], i, obj) === false) break;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 17 */
[77, 58],
/* 18 */
[78, 17, 56, 57],
/* 19 */
[81, 18, 20],
/* 20 */
3,
/* 21 */
[77, 67],
/* 22 */
16,
/* 23 */
[77, 75],
/* 24 */
[78, 23, 72, 73],
/* 25 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(24),
	    getPrototype = __webpack_require__(71),
	    isObjectLike = __webpack_require__(25);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2015
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition();else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else context[name] = definition();
	}('reqwest', undefined, function () {
	
	  var context = this;
	
	  if ('window' in context) {
	    var doc = document,
	        byTag = 'getElementsByTagName',
	        head = doc[byTag]('head')[0];
	  } else {
	    var XHR2;
	    try {
	      XHR2 = __webpack_require__(76);
	    } catch (ex) {
	      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2');
	    }
	  }
	
	  var httpsRe = /^http/,
	      protocolRe = /(^\w+):\/\//,
	      twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  ,
	      readyState = 'readyState',
	      contentType = 'Content-Type',
	      requestedWith = 'X-Requested-With',
	      uniqid = 0,
	      callbackPrefix = 'reqwest_' + +new Date(),
	      lastValue // data stored by the most recent JSONP callback
	  ,
	      xmlHttpRequest = 'XMLHttpRequest',
	      xDomainRequest = 'XDomainRequest',
	      noop = function noop() {},
	      isArray = typeof Array.isArray == 'function' ? Array.isArray : function (a) {
	    return a instanceof Array;
	  },
	      defaultHeaders = {
	    'contentType': 'application/x-www-form-urlencoded',
	    'requestedWith': xmlHttpRequest,
	    'accept': {
	      '*': 'text/javascript, text/html, application/xml, text/xml, */*',
	      'xml': 'application/xml, text/xml',
	      'html': 'text/html',
	      'text': 'text/plain',
	      'json': 'application/json, text/javascript',
	      'js': 'application/javascript, text/javascript'
	    }
	  },
	      xhr = function xhr(o) {
	    // is it x-domain
	    if (o['crossOrigin'] === true) {
	      var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null;
	      if (xhr && 'withCredentials' in xhr) {
	        return xhr;
	      } else if (context[xDomainRequest]) {
	        return new XDomainRequest();
	      } else {
	        throw new Error('Browser does not support cross-origin requests');
	      }
	    } else if (context[xmlHttpRequest]) {
	      return new XMLHttpRequest();
	    } else if (XHR2) {
	      return new XHR2();
	    } else {
	      return new ActiveXObject('Microsoft.XMLHTTP');
	    }
	  },
	      globalSetupOptions = {
	    dataFilter: function dataFilter(data) {
	      return data;
	    }
	  };
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url);
	    protocol = protocol && protocol[1] || context.location.protocol;
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response;
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request);
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout');
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop;
	        if (succeed(r)) success(r.request);else error(r.request);
	      }
	    };
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {},
	        h;
	
	    headers['Accept'] = headers['Accept'] || defaultHeaders['accept'][o['type']] || defaultHeaders['accept']['*'];
	
	    var isAFormData = typeof FormData !== 'undefined' && o['data'] instanceof FormData;
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith'];
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType'];
	    for (h in headers) {
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h]);
	    }
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials'];
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data;
	  }
	
	  function urlappend(url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s;
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++,
	        cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	    ,
	        cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId),
	        cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)'),
	        match = url.match(cbreg),
	        script = doc.createElement('script'),
	        loaded = 0,
	        isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1;
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval); // wildcard callback func name
	      } else {
	        cbval = match[3]; // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval); // no callback details, add 'em
	    }
	
	    context[cbval] = generalCallback;
	
	    script.type = 'text/javascript';
	    script.src = url;
	    script.async = true;
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId;
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if (script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded' || loaded) {
	        return false;
	      }
	      script.onload = script.onreadystatechange = null;
	      script.onclick && script.onclick();
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue);
	      lastValue = undefined;
	      head.removeChild(script);
	      loaded = 1;
	    };
	
	    // Add the script to the DOM head
	    head.appendChild(script);
	
	    // Enable JSONP timeout
	    return {
	      abort: function abort() {
	        script.onload = script.onreadystatechange = null;
	        err({}, 'Request is aborted: timeout', {});
	        lastValue = undefined;
	        head.removeChild(script);
	        loaded = 1;
	      }
	    };
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o,
	        method = (o['method'] || 'GET').toUpperCase(),
	        url = typeof o === 'string' ? o : o['url']
	    // convert non-string objects to query-string form unless o['processData'] is false
	    ,
	        data = o['processData'] !== false && o['data'] && typeof o['data'] !== 'string' ? reqwest.toQueryString(o['data']) : o['data'] || null,
	        http,
	        sendWait = false;
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data);
	      data = null;
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url);
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = o.xhr && o.xhr(o) || xhr(o);
	
	    http.open(method, url, o['async'] === false ? false : true);
	    setHeaders(http, o);
	    setCredentials(http, o);
	    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	      http.onload = fn;
	      http.onerror = err;
	      // NOTE: see
	      // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	      http.onprogress = function () {};
	      sendWait = true;
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err);
	    }
	    o['before'] && o['before'](http);
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data);
	      }, 200);
	    } else {
	      http.send(data);
	    }
	    return http;
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o;
	    this.fn = fn;
	
	    init.apply(this, arguments);
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header === null) return undefined; //In case of no content-type.
	    if (header.match('json')) return 'json';
	    if (header.match('javascript')) return 'js';
	    if (header.match('text')) return 'html';
	    if (header.match('xml')) return 'xml';
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url'];
	    this.timeout = null;
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false;
	    // success handlers
	    this._successHandler = function () {};
	    this._fulfillmentHandlers = [];
	    // error handlers
	    this._errorHandlers = [];
	    // complete (both success and fail) handlers
	    this._completeHandlers = [];
	    this._erred = false;
	    this._responseArgs = {};
	
	    var self = this;
	
	    fn = fn || function () {};
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut();
	      }, o['timeout']);
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments);
	      };
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments);
	      });
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments);
	      });
	    }
	
	    function complete(resp) {
	      o['timeout'] && clearTimeout(self.timeout);
	      self.timeout = null;
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp);
	      }
	    }
	
	    function success(resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')); // resp can be undefined in IE
	      resp = type !== 'jsonp' ? self.request : resp;
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type),
	          r = filteredResponse;
	      try {
	        resp.responseText = r;
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	          case 'json':
	            try {
	              resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')');
	            } catch (err) {
	              return error(resp, 'Could not parse JSON in response', err);
	            }
	            break;
	          case 'js':
	            resp = eval(r);
	            break;
	          case 'html':
	            resp = r;
	            break;
	          case 'xml':
	            resp = resp.responseXML && resp.responseXML.parseError // IE trololo
	            && resp.responseXML.parseError.errorCode && resp.responseXML.parseError.reason ? null : resp.responseXML;
	            break;
	        }
	      }
	
	      self._responseArgs.resp = resp;
	      self._fulfilled = true;
	      fn(resp);
	      self._successHandler(resp);
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp);
	      }
	
	      complete(resp);
	    }
	
	    function timedOut() {
	      self._timedOut = true;
	      self.request.abort();
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request;
	      self._responseArgs.resp = resp;
	      self._responseArgs.msg = msg;
	      self._responseArgs.t = t;
	      self._erred = true;
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t);
	      }
	      complete(resp);
	    }
	
	    this.request = getRequest.call(this, success, error);
	  }
	
	  Reqwest.prototype = {
	    abort: function abort() {
	      this._aborted = true;
	      this.request.abort();
	    },
	
	    retry: function retry() {
	      init.call(this, this.o, this.fn);
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	    , then: function then(success, fail) {
	      success = success || function () {};
	      fail = fail || function () {};
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp);
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	      } else {
	        this._fulfillmentHandlers.push(success);
	        this._errorHandlers.push(fail);
	      }
	      return this;
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	    , always: function always(fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp);
	      } else {
	        this._completeHandlers.push(fn);
	      }
	      return this;
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	    , fail: function fail(fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t);
	      } else {
	        this._errorHandlers.push(fn);
	      }
	      return this;
	    },
	    'catch': function _catch(fn) {
	      return this.fail(fn);
	    }
	  };
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn);
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : '';
	  }
	
	  function serial(el, cb) {
	    var n = el.name,
	        t = el.tagName.toLowerCase(),
	        optCb = function optCb(o) {
	      // IE gives value="" even where there is no value attribute
	      // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	      if (o && !o['disabled']) cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']));
	    },
	        ch,
	        ra,
	        val,
	        i;
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return;
	
	    switch (t) {
	      case 'input':
	        if (!/reset|button|image|file/i.test(el.type)) {
	          ch = /checkbox/i.test(el.type);
	          ra = /radio/i.test(el.type);
	          val = el.value
	          // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	          ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val));
	        }
	        break;
	      case 'textarea':
	        cb(n, normalize(el.value));
	        break;
	      case 'select':
	        if (el.type.toLowerCase() === 'select-one') {
	          optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null);
	        } else {
	          for (i = 0; el.length && i < el.length; i++) {
	            el.options[i].selected && optCb(el.options[i]);
	          }
	        }
	        break;
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this,
	        e,
	        i,
	        serializeSubtags = function serializeSubtags(e, tags) {
	      var i, j, fa;
	      for (i = 0; i < tags.length; i++) {
	        fa = e[byTag](tags[i]);
	        for (j = 0; j < fa.length; j++) {
	          serial(fa[j], cb);
	        }
	      }
	    };
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i];
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb);
	      serializeSubtags(e, ['input', 'select', 'textarea']);
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments));
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {};
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]]);
	        hash[name].push(value);
	      } else hash[name] = value;
	    }, arguments);
	    return hash;
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = [];
	    eachFormElement.apply(function (name, value) {
	      arr.push({ name: name, value: value });
	    }, arguments);
	    return arr;
	  };
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return '';
	    var opt,
	        fn,
	        args = Array.prototype.slice.call(arguments, 0);
	
	    opt = args.pop();
	    opt && opt.nodeType && args.push(opt) && (opt = null);
	    opt && (opt = opt.type);
	
	    if (opt == 'map') fn = serializeHash;else if (opt == 'array') fn = reqwest.serializeArray;else fn = serializeQueryString;
	
	    return fn.apply(null, args);
	  };
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix,
	        i,
	        traditional = trad || false,
	        s = [],
	        enc = encodeURIComponent,
	        add = function add(key, value) {
	      // If value is a function, invoke it and return its value
	      value = 'function' === typeof value ? value() : value == null ? '' : value;
	      s[s.length] = enc(key) + '=' + enc(value);
	    };
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) {
	        add(o[i]['name'], o[i]['value']);
	      }
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add);
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+');
	  };
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name,
	        i,
	        v,
	        rbracket = /\[\]$/;
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i];
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v);
	        } else {
	          buildParams(prefix + '[' + ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? i : '') + ']', v, traditional, add);
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add);
	      }
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj);
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix;
	  };
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type'];
	      o['dataType'] && (o['type'] = o['dataType']);
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback'];
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp']);
	    }
	    return new Reqwest(o, fn);
	  };
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {};
	    for (var k in options) {
	      globalSetupOptions[k] = options[k];
	    }
	  };
	
	  return reqwest;
	});

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _invoker = __webpack_require__(9);
	
	var _reqwest = __webpack_require__(32);
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Invoker = (0, _invoker.createInvoker)('ajax').use(_reqwest2['default']);
	
	exports['default'] = Invoker;
	module.exports = exports['default'];

/***/ },
/* 29 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports['default'] = function (context, next) {
	  var api = context.api,
	      request = context.request,
	      rawReq = context.rawReq;
	
	
	  request.query = {
	    method: api.uri,
	    param: request.query || {},
	    httpMethod: rawReq.method || 'GET'
	  };
	  // 调用 `application` 通用协议接口
	  api.routes = ['application'];
	  api.uri = 'invokeJDYGatewayService';
	  next();
	};
	
	module.exports = exports['default'];

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var callbacks = {
	  // sequence: {Function}
	};
	if (typeof window !== 'undefined') {
	  var win = window;
	  // cache global `onInvokeNotify`
	  var _onInvokeNotify = win.onInvokeNotify;
	  /**
	   * 客户端回调JS的全局回调函数入口
	   * @param  {String} sequence [description]
	   * @param  {Number} code     [description]
	   * @param  {String} result [description]
	   */
	  win.onInvokeNotify = function (sequence, code, result) {
	    var callback = callbacks[sequence];
	    _onInvokeNotify && _onInvokeNotify(sequence, code, result);
	    if (callback) {
	      callback(code, result);
	      delete callbacks[sequence];
	    }
	  };
	}
	
	/**
	 * 调用客户端的 `workbench` 方法
	 * @param  {Object}   options
	 * @param  {String}   options.module    对应 `workbench` 的模块
	 * @param  {String}   options.api       具体的 API 名称
	 * @param  {Object}   options.query     请求参数
	 * @param  {String}   options.method    HTTP 请求方法
	 * @param  {Object}   options.accountId 账号信息，主要用于 千牛企业版 调用 店铺版接口
	 * @param  {String}   options.from      调用来源信息，用于打点
	 * @param  {Function} options.callback  调用返回后需执行的回调函数
	 */
	function invokeNative(options) {
	  var _workbench$module;
	
	  var sequence = workbench.createSequenceId();
	  var module = options.module,
	      api = options.api,
	      query = options.query,
	      method = options.method,
	      accountId = options.accountId,
	      from = options.from,
	      callback = options.callback;
	
	  var args = void 0;
	  query = JSON.stringify(query);
	
	  switch (module) {
	    case 'top':
	    case 'jdy':
	      args = [sequence, api, query, method];
	      break;
	    case 'application':
	      args = [sequence, api, query, from];
	      break;
	    default:
	      args = [sequence, api, query];
	      break;
	  }
	
	  if (accountId) {
	    accountId = JSON.stringify(accountId);
	    args.push(accountId);
	  }
	
	  if (callback) {
	    callbacks[sequence] = callback;
	  }
	
	  (_workbench$module = workbench[module]).invoke.apply(_workbench$module, _toConsumableArray(args));
	}
	
	exports['default'] = function (context, next) {
	  var api = context.api,
	      request = context.request,
	      response = context.response,
	      rawReq = context.rawReq;
	  var routes = api.routes;
	
	
	  request.method = rawReq.method || 'POST';
	
	  invokeNative({
	    module: routes[0],
	    api: api.uri,
	    query: request.query || {},
	    method: request.method,
	    accountId: rawReq.accountId,
	    from: rawReq.from || (workbench.jdy ? 'qn.pcCommon.0.0' : ''),
	    callback: function callback(code, result) {
	      context.rawRes = result;
	      try {
	        result = JSON.parse(result);
	      } catch (ex) {
	        console.warn('[QN-SDK] Native response is not a legal json string.', result);
	      }
	      if (code === 0) {
	        response.body = result;
	      } else {
	        context.error = result;
	      }
	      next();
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qianniuPcApiType = __webpack_require__(5);
	
	var _qianniuPcApiType2 = _interopRequireDefault(_qianniuPcApiType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var QN_APP = _qianniuPcApiType2['default'].QN_APP,
	    TOP = _qianniuPcApiType2['default'].TOP;
	
	exports['default'] = function (context, next) {
	  var api = context.api;
	
	  if (!api.routes) {
	    switch (api.type) {
	      case QN_APP:
	        api.routes = ['application'];
	        break;
	      case TOP:
	        api.routes = ['top'];
	        break;
	      default:
	        // transform `QN.jdy` to `jdy`
	        api.routes = [api.type.replace(/^QN\./, '')];
	    }
	  }
	  next();
	};
	
	module.exports = exports['default'];

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reqwest = __webpack_require__(27);
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (context, next) {
	  var api = context.api,
	      request = context.request,
	      response = context.response,
	      rawReq = context.rawReq;
	
	
	  (0, _reqwest2['default'])({
	    url: api.uri,
	    type: rawReq.type,
	    method: rawReq.method,
	    contentType: rawReq.contentType,
	    headers: rawReq.headers,
	    data: rawReq.data,
	    crossOrigin: rawReq.crossOrigin,
	    withCredentials: rawReq.withCredentials,
	    jsonpCallback: rawReq.jsonpCallback,
	    jsonpCallbackName: rawReq.jsonpCallbackName,
	    success: function success(result) {
	      context.rawRes = result;
	      response.body = result;
	      next();
	    },
	    error: function error(_error) {
	      context.rawRes = _error;
	      context.error = _error;
	      next();
	    }
	  });
	};
	
	module.exports = exports['default'];

/***/ },
/* 33 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports["default"] = function (X) {
	  return function (options) {
	    var api = X.getApiByAlias(options.url);
	
	    options.api = api || {
	      type: X.API_TYPE.AJAX,
	      uri: options.url
	    };
	
	    return X.call(options);
	  };
	};
	
	module.exports = exports["default"];

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.regEvent = regEvent;
	exports.unregEvent = unregEvent;
	exports.postEvent = postEvent;
	
	var _defer = __webpack_require__(11);
	
	var _defer2 = _interopRequireDefault(_defer);
	
	var _json = __webpack_require__(12);
	
	var _eventEmitter = __webpack_require__(10);
	
	var Event = _interopRequireWildcard(_eventEmitter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ee = new Event.EventEmitter();
	var onDefers = {
	  // page.balabala: Promise,
	  // app.haha: Promise,
	};
	var offDefers = {
	  // page.balabala: Promise,
	  // app.haha: Promise,
	};
	
	if (typeof window !== 'undefined') {
	  var win = window;
	  var _onEventNotify = win.onEventNotify;
	
	  win.onEventNotify = function (sequence, ev, code, res, accountId) {
	    _onEventNotify && _onEventNotify(sequence, ev, code, res, accountId);
	    res = (0, _json.tryParse)(res);
	    var onDefer = onDefers[ev];
	    var offDefer = offDefers[ev];
	
	    switch (code) {
	      case 0:
	        // 注册成功
	        onDefer && onDefer.resolve();
	        break;
	      case 1:
	        // 注册失败
	        onDefer && onDefer.reject(res);
	        delete onDefer[ev];
	        break;
	      case 2:
	        // 事件通知
	        ee.emit(ev, res);
	        break;
	      case 3:
	        // 注销成功
	        offDefer && offDefer.resolve();
	        delete onDefers[ev];
	        delete offDefers[ev];
	        break;
	      case 4:
	        // 注销失败
	        offDefer && offDefer.reject(res);
	        break;
	    }
	  };
	}
	
	function regEvent(X) {
	
	  return function (ev, callback) {
	    if (!onDefers[ev]) {
	      onDefers[ev] = (0, _defer2['default'])();
	      workbench.regEvent(workbench.createSequenceId(), ev);
	    }
	
	    var deferred = onDefers[ev];
	    return deferred.promise.then(function () {
	      return ee.on(ev, callback);
	    });
	  };
	}
	
	function unregEvent(X) {
	
	  return function (ev, callback) {
	    return ee.off(ev, callback).then(function (result) {
	      var options = ee.optionsPool[ev];
	      if (options.length > 0) return result;
	      var deferred = offDefers[ev] = (0, _defer2['default'])();
	      workbench.unregEvent(workbench.createSequenceId(), ev);
	      return deferred.promise;
	    });
	  };
	}
	
	function postEvent(X) {
	
	  return function (ev, data) {
	    data = (0, _json.tryStringify)(data || null);
	    workbench.postEvent(ev, data);
	    return Promise.resolve();
	  };
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _qianniuGatewaySettings = __webpack_require__(4);
	
	var _qianniuGatewaySettings2 = _interopRequireDefault(_qianniuGatewaySettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (X) {
	
	  var gatewayURI = {
	    development: '//yungw.daily.taobao.net/gw/invoke/',
	    daily: '//yungw.daily.taobao.net/gw/invoke/',
	    pre: '//yungw.prepub.taobao.com/gw/invoke/',
	    production: 'https://qngateway.taobao.com/gw/invoke/'
	  };
	
	  var gateway = {
	
	    setup: _qianniuGatewaySettings2['default'].setup,
	
	    invoke: function invoke(options) {
	      var query = options.query;
	
	      query = _extends(query || {}, { timestamp: Date.now() });
	
	      // To support api alias, we need to get api info from api map.
	      var api = X.getApiByAlias(options.api);
	
	      api = api || {
	        type: X.API_TYPE.QN_GATEWAY,
	        uri: options.api
	      };
	
	      options.api = {
	        type: X.API_TYPE.AJAX,
	        uri: gatewayURI[X.env] + api.uri
	      };
	      options.data = options.query || {};
	      options.crossOrigin = true;
	      options.withCredentials = true;
	
	      return X.call(options);
	    }
	  };
	
	  return gateway;
	};
	
	module.exports = exports['default'];

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _qianniuPcAppDetect = __webpack_require__(7);
	
	var _qianniuPcAppDetect2 = _interopRequireDefault(_qianniuPcAppDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (X) {
	
	  var doc = document;
	
	  var app = {
	    invoke: function invoke(options) {
	      // To support api alias, we need to get api info from api map.
	      var api = X.getApiByAlias(options.api);
	      options.api = api || {
	        type: X.API_TYPE.QN_APP,
	        uri: options.api
	      };
	
	      return X.call(options);
	    },
	
	
	    name: _qianniuPcAppDetect2['default'].isQianniu ? 'qianniu' : 'web'
	  };
	
	  return app;
	};
	
	module.exports = exports['default'];

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _each = __webpack_require__(44);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _isFunction = __webpack_require__(50);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _qianniuPc = __webpack_require__(8);
	
	var _qianniuPc2 = _interopRequireDefault(_qianniuPc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var win = window;
	var doc = document;
	var EXCLUDES = {
	  application: true,
	  top: true
	};
	
	/**
	 * create a X plugin by name which from module of `window.workbench`.
	 * @param  {String} name  plugin name
	 * @return {Function}     new X plugin
	 */
	function createPlugin(name) {
	  return function (X) {
	    var plugin = {
	      invoke: function invoke(options) {
	        // To support api alias, we need to get api info from api map.
	        var api = X.getApiByAlias(options.api);
	        options.api = api || {
	          type: X.API_TYPE['QN_' + name.toUpperCase()],
	          uri: options.api
	        };
	        return X.call(options);
	      }
	    };
	    return plugin;
	  };
	}
	
	exports['default'] = function (X) {
	
	  function autoPlug() {
	    if (!win.workbench) return;
	
	    (0, _each2['default'])(workbench, function (module, moduleName) {
	      if (!module || !(0, _isFunction2['default'])(module.invoke)) return;
	      if (EXCLUDES[moduleName]) return;
	
	      var type = X.API_TYPE['QN_' + moduleName.toUpperCase()] = 'QN.' + moduleName;
	      X.addInvoker((0, _qianniuPc2['default'])(type));
	      X.plug(moduleName, createPlugin(moduleName));
	    });
	  }
	
	  // support async import
	  if (doc.readyState === 'complete') {
	    autoPlug();
	  } else {
	    if (!doc.addEventListener) return;
	    doc.addEventListener('DOMContentLoaded', autoPlug);
	  }
	};
	
	module.exports = exports['default'];

/***/ },
/* 38 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var env = void 0;
	
	var _location = location,
	    host = _location.host,
	    search = _location.search;
	
	
	switch (true) {
	  // Test if pre env first for `pre.xxx.taobao.com` like host
	  case /(^|\.)(pre|wapa)\./.test(host): // `pre.taobao.com` `wapp.wapa.taobao.com`
	  case /(\?|&)pre=(1|true)(&|$)/.test(search):
	    // `?pre=1` `&pre=true`
	    env = 'pre';
	    break;
	
	  case /\.taobao\.com/.test(host):
	  case /(\?|&)(production|online)=(1|true)(&|$)/.test(search):
	    // `?production=1` `&local=online`
	    env = 'production';
	    break;
	
	  case /(^|\.)(daily|waptest)\./.test(host): // `login.daily.taobao.net` `wapp.waptest.taobao.com`
	  case /(\?|&)daily=(1|true)(&|$)/.test(search):
	    // `?daily=1` `&daily=true`
	    env = 'daily';
	    break;
	
	  case /^localhost/.test(host): // `localhost:8080`
	  case /(^|\.)(debug|dev|development|local)\./.test(host): // `local.taobao.net`
	  case /(\d+\.){3}\d+/.test(host): // `30.5.88.22`
	  case /(\?|&)(debug|dev|development|local)=(1|true)(&|$)/.test(search):
	    // `?development=1` `&local=true`
	    env = 'development';
	    break;
	
	  default:
	    env = 'production';
	}
	
	exports['default'] = env;
	module.exports = exports['default'];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.on = on;
	exports.off = off;
	exports.emit = emit;
	
	var _defer = __webpack_require__(11);
	
	var _defer2 = _interopRequireDefault(_defer);
	
	var _json = __webpack_require__(12);
	
	var _eventEmitter = __webpack_require__(10);
	
	var Event = _interopRequireWildcard(_eventEmitter);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ee = new Event.EventEmitter();
	var onDefers = {
	  // Page.balabala: Promise,
	  // App.haha: Promise,
	};
	var offDefers = {
	  // Page.balabala: Promise,
	  // App.haha: Promise,
	};
	
	function autoPrefixEvent(ev) {
	  var r = /^(page|app|global)\.(.+)$/i;
	
	  /**
	   * if none of formats below, prefix default type.
	   * Page.foo
	   * App.foo.bar
	   * Global.foo.bar
	   */
	  if (!r.test(ev)) {
	    ev = 'Page.' + ev;
	  }
	
	  return ev;
	}
	
	if (typeof window !== 'undefined') {
	  var win = window;
	  var _onEventNotify = win.onEventNotify;
	
	  win.onEventNotify = function (sequence, ev, code, res, accountId) {
	    _onEventNotify && _onEventNotify(sequence, ev, code, res, accountId);
	    res = (0, _json.tryParse)(res);
	    var onDefer = onDefers[ev];
	    var offDefer = offDefers[ev];
	
	    switch (code) {
	      case 0:
	        // 注册成功
	        onDefer && onDefer.resolve();
	        break;
	      case 1:
	        // 注册失败
	        onDefer && onDefer.reject(res);
	        delete onDefer[ev];
	        break;
	      case 2:
	        // 事件通知
	        ee.emit(ev, res);
	        break;
	      case 3:
	        // 注销成功
	        offDefer && offDefer.resolve();
	        delete onDefers[ev];
	        delete offDefers[ev];
	        break;
	      case 4:
	        // 注销失败
	        offDefer && offDefer.reject(res);
	        break;
	    }
	  };
	}
	
	function on(X) {
	
	  return function (ev, callback) {
	    ev = autoPrefixEvent(ev);
	
	    if (!onDefers[ev]) {
	      onDefers[ev] = (0, _defer2['default'])();
	      workbench.regScopeEvent(workbench.createSequenceId(), ev);
	    }
	
	    var deferred = onDefers[ev];
	    return deferred.promise.then(function () {
	      ee.on(ev, callback);
	    });
	  };
	}
	
	function off(X) {
	
	  return function (ev, callback) {
	    ev = autoPrefixEvent(ev);
	
	    return ee.off(ev, callback).then(function (result) {
	      var options = ee.optionsPool[ev];
	      if (options.length > 0) return result;
	      if (!onDefers[ev]) return result;
	      var deferred = offDefers[ev] = (0, _defer2['default'])();
	      workbench.unregScopeEvent(workbench.createSequenceId(), ev);
	      return deferred.promise;
	    });
	  };
	}
	
	function emit(X) {
	
	  return function (ev, data) {
	    ev = autoPrefixEvent(ev);
	    data = (0, _json.tryStringify)(data || null);
	    workbench.postEvent(ev, data);
	    return Promise.resolve();
	  };
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _qianniuGatewaySettings = __webpack_require__(4);
	
	var _qianniuGatewaySettings2 = _interopRequireDefault(_qianniuGatewaySettings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (X) {
	
	  var gateway = {
	
	    setup: _qianniuGatewaySettings2['default'].setup,
	
	    invoke: function invoke(options) {
	      // To support api alias, we need to get api info from api map.
	      var api = X.getApiByAlias(options.api);
	      var query = options.query,
	          settings = options.settings;
	
	      query = query || {};
	      settings = settings || {};
	      settings = _assign2['default'].deep({}, _qianniuGatewaySettings2['default'].get(), settings);
	
	      options.api = api || {
	        type: X.API_TYPE.QN_GATEWAY,
	        uri: options.api
	      };
	
	      /**
	       * `response_style` 优先级：
	       * 1. 用户 `options.query.response_style`
	       * 2. 用户 `options.settings.response_style`
	       * 3. `gatewaySettings.response_style`
	       */
	      if (!query.hasOwnProperty('response_style')) {
	        query.response_style = settings.response_style;
	      }
	      if (query.response_style !== 'h5_style') {
	        delete query.response_style;
	      }
	
	      return X.call(options);
	    }
	  };
	
	  return gateway;
	};
	
	module.exports = exports['default'];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(6);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _qianniuGatewaySettings = __webpack_require__(4);
	
	var _qianniuGatewaySettings2 = _interopRequireDefault(_qianniuGatewaySettings);
	
	var _qianniuPcGatewayByNative = __webpack_require__(40);
	
	var _qianniuPcGatewayByNative2 = _interopRequireDefault(_qianniuPcGatewayByNative);
	
	var _qianniuGatewayByAjax = __webpack_require__(35);
	
	var _qianniuGatewayByAjax2 = _interopRequireDefault(_qianniuGatewayByAjax);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = function (X) {
	
	  var _gatewayByNative = (0, _qianniuPcGatewayByNative2['default'])(X);
	  var _gatewayByAjax = (0, _qianniuGatewayByAjax2['default'])(X);
	
	  var gateway = {
	
	    setup: _qianniuGatewaySettings2['default'].setup,
	
	    invoke: function invoke(options) {
	      // To support api alias, we need to get api info from api map.
	      var settings = _assign2['default'].deep({}, _qianniuGatewaySettings2['default'].get(), options.settings || {});
	      var gateway = settings.useAjax ? _gatewayByAjax : _gatewayByNative;
	
	      return gateway.invoke(options);
	    }
	  };
	
	  return gateway;
	};
	
	module.exports = exports['default'];

/***/ },
/* 42 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports["default"] = function (X) {
	
	  var top = {
	    invoke: function invoke(options) {
	      // To support api alias, we need to get api info from api map.
	      var api = X.getApiByAlias(options.query.method);
	      options.api = api || {
	        type: X.API_TYPE.TOP,
	        uri: options.query.method
	      };
	
	      return X.call(options);
	    }
	  };
	
	  return top;
	};
	
	module.exports = exports["default"];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(15);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _each = __webpack_require__(16);
	
	var _each2 = _interopRequireDefault(_each);
	
	var _isString = __webpack_require__(61);
	
	var _isString2 = _interopRequireDefault(_isString);
	
	var _isObject = __webpack_require__(20);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _isFunction = __webpack_require__(19);
	
	var _isFunction2 = _interopRequireDefault(_isFunction);
	
	var _context = __webpack_require__(14);
	
	var _context2 = _interopRequireDefault(_context);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AsyncInvokers = {
	  // type: invoker
	};
	
	var SyncInvokers = {
	  // type: invoker
	};
	
	var settings = {
	  api: {
	    /**
	     * alias: {type: 'ajax', uri: '//api.com/get-something/'}
	     */
	  }
	};
	
	var Core = {
	  setup: function setup(options) {
	    _assign2.default.deep(settings, options);
	    return this;
	  },
	  call: function call(options) {
	    /**
	     * api info
	     * @type {Object}
	     * @type {String} api.type       API 类型
	     * @type {String} api.alias      API 别名
	     * @type {String} api.uri        API 识别标志
	     * @type {Array}  api.routes     API 请求路径
	     */
	    var api = options.api;
	
	
	    options.__X__ = this;
	    var Invokers = api.sync ? SyncInvokers : AsyncInvokers;
	    var Invoker = Invokers[api.type];
	    var invokerInstace = new Invoker(options);
	
	    return invokerInstace.call();
	  },
	  getApiByAlias: function getApiByAlias(alias) {
	    /**
	     * api info
	     * @type {Object}
	     * @type {String} api.type       API 类型
	     * @type {String} api.alias      API 别名
	     * @type {String} api.uri        API 识别标志
	     * @type {Array}  api.routes     API 请求路线
	     */
	    var api = settings.api[alias] || null;
	    if (api) {
	      api = (0, _assign2.default)({ alias: alias }, api);
	    }
	    return api;
	  },
	  addInvoker: function addInvoker(Invoker) {
	    var Invokers = Invoker.sync ? SyncInvokers : AsyncInvokers;
	    Invokers[Invoker.type] = Invoker;
	    return this;
	  },
	  getSyncInvoker: function getSyncInvoker(type) {
	    return SyncInvokers[type] || null;
	  },
	  getAsyncInvoker: function getAsyncInvoker(type) {
	    return AsyncInvokers[type] || null;
	  },
	
	
	  // 插件扩展接口
	  plug: function plug(name, plugin) {
	    var Core = this;
	    // 多个 plugin 的 map 形式
	    function plug(plugin, name) {
	      if (Core[name]) {
	        if (false) {
	          console.warn('SDK plugin ' + name + ' already exists.');
	        }
	        return;
	      }
	      var pluginReturn = (0, _isFunction2.default)(plugin) ? plugin(Core) : plugin;
	      if (pluginReturn) {
	        Core[name] = pluginReturn;
	      }
	    }
	    if ((0, _isObject2.default)(name)) {
	      (0, _each2.default)(name, plug);
	    } else {
	      plug(plugin, name);
	    }
	    return this;
	  }
	};
	
	exports.default = Core;
	module.exports = exports['default'];

/***/ },
/* 44 */
16,
/* 45 */
[78, 13, 47, 48],
/* 46 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 47 */
[79, 13],
/* 48 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 49 */
[80, 46],
/* 50 */
[81, 45, 51],
/* 51 */
3,
/* 52 */
11,
/* 53 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * 已知问题：
	 * 1. 不支持 NaN 作为 key
	 */
	
	var LiteMap = function () {
	  function LiteMap() {
	    var _this = this;
	
	    var kvs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, LiteMap);
	
	    this._keys = [];
	    this._values = [];
	    this.size = 0;
	
	    kvs.forEach(function (kv) {
	      _this._keys.push(kv[0]);
	      _this._values.push(kv[1]);
	    });
	    this.size = kvs.length;
	  }
	
	  LiteMap.prototype.clear = function clear() {
	    this._keys = [];
	    this._values = [];
	    this.size = 0;
	  };
	
	  LiteMap.prototype.delete = function _delete(key) {
	    var _keys = this._keys,
	        _values = this._values;
	
	    var i = _keys.indexOf(key);
	    if (i < 0) return;
	    _keys.splice(i, 1);
	    _values.splice(i, 1);
	    this.size--;
	  };
	
	  LiteMap.prototype.forEach = function forEach(callback) {
	    var _keys = this._keys,
	        _values = this._values;
	
	    for (var i = 0; i < _keys.length; i++) {
	      callback(_values[i], _keys[i]);
	    }
	  };
	
	  LiteMap.prototype.get = function get(key) {
	    var _keys = this._keys,
	        _values = this._values;
	
	    var i = _keys.indexOf(key);
	    return _values[i];
	  };
	
	  LiteMap.prototype.has = function has(key) {
	    return Boolean(this._keys.indexOf(key) >= 0);
	  };
	
	  LiteMap.prototype.keys = function keys() {
	    return this._keys.slice();
	  };
	
	  LiteMap.prototype.set = function set(key, value) {
	    var _keys = this._keys,
	        _values = this._values;
	
	    var i = _keys.indexOf(key);
	    i = i < 0 ? _keys.length : i;
	    _keys[i] = key;
	    _values[i] = value;
	    this.size = _keys.length;
	  };
	
	  LiteMap.prototype.values = function values() {
	    return this._values.slice();
	  };
	
	  return LiteMap;
	}();
	
	exports.default = LiteMap;
	module.exports = exports["default"];

/***/ },
/* 54 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = uuid;
	function uuid() {
	  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    var r = Math.random() * 16 | 0;
	    var v = c == 'x' ? r : r & 0x3 | 0x8;
	    return v.toString(16);
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 55 */
46,
/* 56 */
[79, 17],
/* 57 */
48,
/* 58 */
[80, 55],
/* 59 */
1,
/* 60 */
25,
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(18),
	    isArray = __webpack_require__(59),
	    isObjectLike = __webpack_require__(60);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 62 */
16,
/* 63 */
[78, 21, 65, 66],
/* 64 */
46,
/* 65 */
[79, 21],
/* 66 */
48,
/* 67 */
[80, 64],
/* 68 */
[81, 63, 69],
/* 69 */
3,
/* 70 */
46,
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(74);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 72 */
[79, 23],
/* 73 */
48,
/* 74 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 75 */
[80, 70],
/* 76 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var root = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__),
	    getRawTag = __webpack_require__(__webpack_module_template_argument_1__),
	    objectToString = __webpack_require__(__webpack_module_template_argument_2__);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var Symbol = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var freeGlobal = __webpack_require__(__webpack_module_template_argument_0__);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var baseGetTag = __webpack_require__(__webpack_module_template_argument_0__),
	    isObject = __webpack_require__(__webpack_module_template_argument_1__);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }
/******/ ])))
});
;


// WEBPACK FOOTER //
// qn.min.js